/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import { Helmet } from "react-helmet"
import { useStaticQuery, graphql } from "gatsby"

const SEO = ({ description, lang, meta, title, opengraphImage, canonical, metaRobotsNoindex, metaRobotsNofollow }) => {
  const { wp, wpUser } = useStaticQuery(
    graphql`
      query {
        wp {
          generalSettings {
            title
            description
          }
          seo {
            social {
              facebook {
                defaultImage {
                  localFile {
                    childImageSharp {
                      fixed(width: 1000, quality: 80) {
                        ...GatsbyImageSharpFixed
                      }
                    }
                  }
                }
              }
            }
          }
        }

        # if there's more than one user this would need to be filtered to the main user
        wpUser {
          twitter: name
        }
      }
    `
  )

  const metaDescription = description || wp.generalSettings?.description
  const defaultTitle = wp.generalSettings?.title
  const ogImage = opengraphImage || `https://www.standbyproductions.co.uk${wp.seo?.social?.facebook?.defaultImage?.localFile?.childImageSharp?.fixed.src}`
  
  // Initialize an array to hold robots directives
  const robotsDirectives = [];

  // Add 'noindex' to the directives if metaRobotsNoIndex has a value
  if (metaRobotsNoindex) robotsDirectives.push(metaRobotsNoindex);

  // Add 'nofollow' to the directives if metaRobotsNoFollow has a value
  if (metaRobotsNofollow) robotsDirectives.push(metaRobotsNofollow);

  // Join the directives with a comma and space to form the robots content
  const robotsContent = robotsDirectives.join(', ');
  let newCanonical;
  if(canonical) {
    if(canonical.includes('http')) {
      newCanonical = canonical;
    } else {
      newCanonical = 'https://www.standbyproductions.co.uk' + canonical;
    }
  }

  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      bodyAttributes={{
        class: 'antialiased bg-white'
      }}
      title={title}
      titleTemplate={defaultTitle ? `%s | ${defaultTitle}` : null}
      meta={[
        {
          name: `description`,
          content: metaDescription,
        },
        {
          property: `og:title`,
          content: title,
        },
        {
          property: `og:description`,
          content: metaDescription,
        },
        {
          property: `og:type`,
          content: `website`,
        },
        {
          name: `twitter:card`,
          content: `summary`,
        },
        {
          name: `twitter:creator`,
          content: wpUser?.twitter || ``,
        },
        {
          name: `twitter:title`,
          content: title,
        },
        {
          name: `twitter:description`,
          content: metaDescription,
        },
        {
          name: `image`,
          property: `og:image`,
          content: ogImage,
        },
        // Conditionally add the robots meta tag if either noindex or nofollow is set
        ...(robotsContent ? [{
          name: 'robots',
          content: robotsContent,
        }] : []),
      ].concat(meta)}
    >
      
      {newCanonical && <link rel="canonical" href={newCanonical} />}

    </Helmet>
  )
}

SEO.defaultProps = {
  lang: `en`,
  meta: [],
  description: ``,
}

SEO.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string.isRequired,
}

export default SEO
